export const langRemove = {
  fr: {
    deleteConfirm: 'Confirmez-vous la suppression de ',
    deleteSessionConfirm: 'Confirmez-vous la suppression de la session ',
    deleteUserConfirm1: `Confirmez-vous la suppression de l'utilisateur `,
    deleteUserConfirm2: ` et de toutes les données enregistrées ? Attention, cette suppression ne peut pas être annulée.`,
    cancel: 'Annuler',
    confirm: 'Supprimer',
  },
  eng: {
    deleteConfirm: 'Confirm remove of  ',
    deleteSessionConfirm: 'Confirm remove of session ',
    deleteUserConfirm1: `Do you confirm removing user  `,
    deleteUserConfirm2: ` and all saved data ? This cannot be undone.`,
    cancel: 'Cancel',
    confirm: 'Remove',
  },
}
